import { render, staticRenderFns } from "./ContasBancarias.vue?vue&type=template&id=259b54df"
import script from "./ContasBancarias.vue?vue&type=script&lang=js"
export * from "./ContasBancarias.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports